export default __webpack_public_path__ + "static/media/coverPhoto.c48bcdce.jpg";